import { useHandleResize } from "@hook";
import { getSqlServerGuidHash, sendMetric, getWhatId, clearParamWithoutRerender, getAbTestMetrika, pluralForm, getOfferLegalInfo } from "@utils";

import { inject, observer } from "mobx-react";
import { useState } from "react";

import { v4 as uuidv4 } from "uuid";
// import CyrillicToTranslit from "cyrillic-to-translit-js";

import ClosedQuestion from "./ClosedQuestion";
import pencil from "./img/Edit_icon.gif";
import light from "./img/light.svg";
import people from "./img/people.svg";

import InheritGeo from "./InheritGeo";
import SelectingOptions from "./SelectingOptions";
import { normalizeOfferId } from "../../../../helpers/duplicateOffers";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const dataDefault = {
    offerId: null, //offerId
    vendorId: null, //vendorId
    surveyId: null, //formTemplateId
    surveyUuid: uuidv4(), //это уникальный ключ для каждой вопросильеной сессиии генерится фронтом
    status: "inProgress", //всегда отпрявляем inProgress если закончил с промо то finishedPromo если пошел нахуй то finishedOut
    answers: {
        questionId: null, //id вопрос хз как ты его там заводишь)
        question: null, //Текст самого вопроса
        answer: null, // ответ на вопрос
    },
};

const Default = inject("mainStore")(
    observer(({ mainStore, item, setStateAnswer, index, stateAnswer, promo, formTemplate, offerId, vendorId, setIsAccordionOpen, surveyId, setPercentNumber = () => {}, number, time }) => {
        const abTest = mainStore.getMainStore("abTest");
        const abTestMetika = mainStore.getMainStore("abTestMetika");

        const [limit, setLimit] = useState(false);
        const [dataItem, setDataItem] = useState(item);
        const [dataItemStack, setDataItemStack] = useState([]);

        const isMobile = useHandleResize();
        const { showLegalInfo } = getOfferLegalInfo(promo);
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const isAbTestMetrika = getAbTestMetrika(abTest, promo?._id);
        const { regionIds, cityIds, metroStationIds } = extractGeoArrays(promo?.geoObject);

        const Specified = wrap[dataItem.type] ? wrap[dataItem.type] : ClosedQuestion;

        let url = new URL(window.location.href);
        if (url.searchParams.get("id")) {
            url.searchParams.delete("id");
        }
        if (url.searchParams.get("code")) {
            url.searchParams.delete("code");
        }

        const handleClickExit = () => {
            mainStore.setMainStore("formQuestionsChain", []);
            clearParamWithoutRerender(["id", "code"]);
            sendMetric("click_offer_button_restrictionTrigger_exit", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: promo._id,
                params3: getSqlServerGuidHash(promo.code, promo.vendor?._id),
                params4: promo?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });

            if (isMobile) {
                setIsAccordionOpen(false);
                setStateAnswer(0);
            }

            mainStore.setMainStore("modal", false);
        };

        const formTemplateAnswerState = async (itemOptions, type = false, item) => {
            const dataAnswer = {
                ...dataDefault,
                offerId: normalizeOfferId(offerId), //offerId
                vendorId: vendorId, //vendorId
                surveyId: surveyId, //formTemplateId
                status: "inProgress", //всегда отпрявляем inProgress если закончил с промо то finishedPromo если пошел нахуй то finishedOut
                answers: {
                    questionId: dataItem._id, //id вопрос хз как ты его там заводишь)
                    question: dataItem.question, //Текст самого вопроса
                    answer: itemOptions, // ответ на вопрос
                },
            };

            setPercentNumber((prev) => prev + 10);

            if (type === "geo") {
                if (itemOptions._id === "123") {
                    setLimit({
                        isLimitText: item.options[0].isLimitText,
                        isLimitButtonText: item.options[0].isLimitButtonText,
                    });
                    dataAnswer.status = "finishedOut";
                    setTimeout(() => {
                        dataAnswer.surveyUuid = uuidv4();
                    });
                    sendMetric("click_offer_button_restrictionTrigger", {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: promo._id,
                        params3: getSqlServerGuidHash(promo.code, promo.vendor?._id),
                        params4: promo?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                } else {
                    let isGeoRegion = regionIds.some((el) => itemOptions._id === el);
                    let isGeoCity = cityIds.some((el) => itemOptions._id === el);
                    let isGeoMetro = metroStationIds && metroStationIds.some((el) => (itemOptions.metro ? itemOptions.metro.find((i) => i._id === el) : itemOptions._id === el));

                    if (!isGeoMetro) {
                        dataAnswer.status = "inProgress";
                        setStateAnswer(index + 1);
                    }

                    if (isGeoRegion) {
                        if (targetIds.includes(itemOptions._id)) {
                            if (!isGeoMetro) {
                                setStateAnswer(6);
                            } else {
                                setStateAnswer(index + 2);
                            }
                        }

                        if (targetIds.includes(itemOptions._id) && formTemplate.length < 3) {
                            if (!isGeoMetro) {
                                setStateAnswer(6);
                            } else {
                                setStateAnswer(index + 1);
                            }
                        }

                        if (targetIds.includes(itemOptions._id) && !formTemplate.some((i) => i.typeQuestions === "metro")) {
                            setStateAnswer(6);
                        }
                        dataAnswer.status = "inProgress";
                    } else {
                        if (isGeoCity) {
                            if (itemOptions.metro && !itemOptions.metro.length) {
                                dataAnswer.status = "inProgress";
                                setStateAnswer(index + 1);
                                let idx = formTemplate.findIndex((i) => i.type === "question");
                                if (idx > 0) {
                                    setStateAnswer(idx);
                                } else {
                                    setStateAnswer(6);
                                }
                            } else {
                                if (isGeoMetro) {
                                    dataAnswer.status = "inProgress";
                                    setStateAnswer(index + 1);
                                } else {
                                    dataAnswer.status = "inProgress";
                                    setStateAnswer(index + 2);
                                }
                            }
                        } else {
                            dataAnswer.status = "inProgress";
                            setStateAnswer(index + 1);
                        }
                    }
                }
            } else {
                if (type === "select") {
                    if (itemOptions && item.children.length && !itemOptions.some((el) => el.isLimit)) {
                        let obj = item.children.find((el) => el._id === itemOptions.find((i) => i.relaitedId).relaitedId);
                        setDataItemStack((prev) => [...prev, dataItem]);
                        setDataItem(obj);
                        dataAnswer.status = "inProgress";
                    } else {
                        if (itemOptions && itemOptions.some((el) => el.isLimit)) {
                            let obj = itemOptions.find((el) => el.isLimit);
                            setLimit({
                                isLimitText: obj.isLimitText ? obj.isLimitText : "",
                                isLimitButtonText: obj.isLimitButtonText,
                            });
                            dataAnswer.status = "finishedOut";
                            setTimeout(() => {
                                dataAnswer.surveyUuid = uuidv4();
                            });

                            sendMetric("click_offer_button_restrictionTrigger", {
                                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                                params2: promo._id,
                                params3: getSqlServerGuidHash(promo.code, promo.vendor?._id),
                                params4: promo?.code,
                                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                                params7: null,
                                params8: what_id,
                            });
                        } else {
                            dataAnswer.status = "inProgress";
                            setStateAnswer(index + 1);
                        }
                    }
                } else {
                    if (itemOptions.isLimit) {
                        setLimit({
                            isLimitText: itemOptions.isLimitText ? itemOptions.isLimitText : "",
                            isLimitButtonText: itemOptions.isLimitButtonText,
                        });
                        dataAnswer.status = "finishedOut";
                        setTimeout(() => {
                            dataAnswer.formTemplateUuid = uuidv4();
                        });

                        sendMetric("click_offer_button_restrictionTrigger", {
                            params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                            params2: promo._id,
                            params3: getSqlServerGuidHash(promo.code, promo.vendor?._id),
                            params4: promo?.code,
                            params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                            params7: null,
                            params8: what_id,
                        });
                    } else {
                        if (itemOptions.relaitedId) {
                            let obj = item.children.find((el) => el._id === itemOptions.relaitedId);
                            setDataItemStack((prev) => [...prev, dataItem]);
                            setDataItem(obj);
                            dataAnswer.status = "inProgress";
                        } else {
                            dataAnswer.status = "inProgress";
                            setStateAnswer(index + 1);
                        }
                    }
                }
            }

            if (stateAnswer + 1 >= promo.formTemplate?.length) {
                dataAnswer.status = "finishedPromo";
                setTimeout(() => {
                    dataDefault.formTemplateUuid = uuidv4();
                });
            }

            if (type !== "geo") {
                const formQuestionsChain = mainStore.getMainStore("formQuestionsChain") || [];

                const normalizeAnswerValue = (item) => item?.text || item?.title || item?.name || item;

                const normalizedAnswer = Array.isArray(dataAnswer.answers.answer) ? dataAnswer.answers.answer.map(normalizeAnswerValue) : normalizeAnswerValue(dataAnswer.answers.answer);

                mainStore.setMainStore("formQuestionsChain", [
                    ...formQuestionsChain.slice(0, index),
                    {
                        question: dataItem.question,
                        answer: normalizedAnswer,
                    },
                ]);
            }

            await mainStore.postByUrl("app_rispromo/form_question", dataAnswer, false, false, "", false);

            // if (type === "useGeo") {
            //     let isGeoRegion = promo.regionIds.some((el) => itemOptions[0]._id === el);
            //     let isGeoCity = promo.cityIds.some((el) => itemOptions[0]._id === el);
            //     let isGeoMetro = promo.metroStationIds && promo.metroStationIds.some((el) => arrValue[0]._id === el);

            //     if (isGeoMetro) {
            //         dataAnswer.status = "inProgress";
            //         setStateAnswer(index + 1);
            //     }

            //     if (isGeoRegion) {

            //         if (arrValue[0]._id === "664746e41feb2258b05f5e68" || arrValue[0]._id === "664746e41feb2258b05f5e69") {
            //             dataAnswer.status = "inProgress";
            //             setStateAnswer(index + 2);
            //         } else {
            //             dataAnswer.status = "inProgress";
            //             setStateAnswer(index + 1);
            //         }

            //     } else {
            //         if (isGeoCity) {

            //             if (arrValue[0].metro && !arrValue[0].metro.length) {
            //                 dataAnswer.status = "inProgress";
            //                 setStateAnswer(6);
            //             } else {
            //                 dataAnswer.status = "inProgress";
            //                 setStateAnswer(index + 1);
            //             }

            //         } else {
            //             // setLimit(arrValue[0].restrictedMessage ? arrValue[0].restrictedMessage : true);
            //             dataAnswer.status = "finishedOut";
            //             setTimeout(() => {
            //                 dataAnswer.formTemplateUuid = uuidv4();
            //             });

            //             sendMetric("click_offer_button_restrictionTrigger", {
            //                 params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
            //                 params2: "Клик по кнопке с ограничением",
            //                 params3: getSqlServerGuidHash(promo.code, promo.vendor?._id),
            //                 params4: promo?._id,
            //                 params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
            //                 params7: null,
            //                 params8: what_id
            //             })
            //         }
            //     }
            // } else {
            // if (type === "select") {
            // if (arrValue && arrValue.some((el) => el.connected)) {
            //     let obj = arrValue.find((el) => el.connected);
            //     let nextItem = item.content.find((el) =>
            //         el.triggerId.slice("_").includes(CyrillicToTranslit().transform(`${obj.value}`).replace(/\s/gim, "")),
            //     );
            //     setDataItem(nextItem);
            //     setDataItemConnect(item);
            //     dataAnswer.status = "inProgress";
            // } else {
            //     if (arrValue && arrValue.some((el) => el.restrictionTrigger)) {
            //         let obj = arrValue.find((el) => el.restrictionTrigger);
            //         setRestriction(obj.restrictedMessage ? obj.restrictedMessage : true);
            //         setDataItemConnect(false);
            //         dataAnswer.status = "finishedOut";
            //         setTimeout(() => {
            //             dataAnswer.formTemplateUuid = uuidv4();
            //         });

            //         let isAbTestMetrika = false;
            //         for (let [key, value] of Object.entries(abTest)) {
            //             if (key.split("_").includes(promo._id)) {
            //                 isAbTestMetrika = value;
            //             }
            //         }

            //         sendMetric("click_offer_button_restrictionTrigger", {
            //             params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
            //             params2: "Клик по кнопке с ограничением",
            //             params3: getSqlServerGuidHash(promo.code, promo.vendor?._id),
            //             params4: promo?._id,
            //             params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
            //             params7: null,
            //             params8: what_id
            //         })
            //     } else {
            //         dataAnswer.status = "inProgress";
            //         setStateAnswer(index + 1);
            //     }
            // }
            // } else {
            //     if (arrValue && arrValue[0].connected) {
            //         let nextItem = item.content.find((el) =>
            //             el.triggerId.slice("_").includes(CyrillicToTranslit().transform(`${arrValue[0].value}`).replace(/\s/gim, "")),
            //         );
            //         setDataItem(nextItem);
            //         setDataItemConnect(item);
            //         dataAnswer.status = "inProgress";
            //     } else {
            //         if (arrValue[0].isLimit) {
            //             setLimit(
            //                 {
            //                     isLimitText: arrValue[0].isLimitText ? arrValue[0].isLimitText : '',
            //                     isLimitButtonText: arrValue[0].isLimitButtonText
            //                 }
            //             );
            //             dataAnswer.status = "finishedOut";
            //             setTimeout(() => {
            //                 dataAnswer.formTemplateUuid = uuidv4();
            //             });

            //             let isAbTestMetrika = false;
            //             for (let [key, value] of Object.entries(abTest)) {
            //                 if (key.split("_").includes(promo._id)) {
            //                     isAbTestMetrika = value;
            //                 }
            //             }

            //             sendMetric("click_offer_button_restrictionTrigger", {
            //                 params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
            //                 params2: "Клик по кнопке с ограничением",
            //                 params3: getSqlServerGuidHash(promo.code, promo.vendor?._id),
            //                 params4: promo?._id,
            //                 params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
            //                 params7: null,
            //                 params8: what_id
            //             })
            //         } else {
            //             dataAnswer.status = "inProgress";
            //             setStateAnswer(index + 1);
            //         }
            //     }
            // }
            // }

            // mainStore.postByUrl('app_rispromo/form_question', dataAnswer, false, '', false);
        };

        const handleStepBack = () => {
            if (dataItemStack.length) {
                setDataItem(dataItemStack[dataItemStack.length - 1]);
                setDataItemStack((prev) => prev.slice(0, -1));
            } else if (stateAnswer) {
                setStateAnswer((prev) => prev - 1);
            }
        };

        const percentFilling = () => {
            if (formTemplate.length) {
                let number = 10 * (index + 1);

                if (index == 1) {
                    number = 20;
                    setPercentNumber(number);
                    return number;
                }
                setPercentNumber(number);
                return number;
            }
        };

        return (
            <div style={{ marginBottom: "16px" }}>
                <div className="offer__progressbar">
                    <div className="offer__progressbar-header">
                        <img src={pencil} />
                        <span className="offer__progressbar-text">Ответьте на вопросы, чтобы получить подарок</span>
                        <span className="offer__progressbar-value">{percentFilling() <= 10 ? 0 : percentFilling()}%</span>
                    </div>
                    <div className="offer__progressbar-line">
                        <div className="line__filling" style={{ width: `${percentFilling() <= 10 ? 4 : percentFilling()}%` }}></div>
                    </div>
                </div>

                {Specified ? (
                    <Specified
                        item={dataItem}
                        setStateAnswer={setStateAnswer}
                        formTemplateAnswerState={formTemplateAnswerState}
                        setLimit={setLimit}
                        limit={limit}
                        handleClickExit={handleClickExit}
                        promo={promo}
                        stateAnswer={stateAnswer}
                        handleStepBack={handleStepBack}
                        dataItemConnect={dataItemStack.length > 0}
                        formTemplate={formTemplate}
                    />
                ) : null}

                {!Specified && !promo.ghostOffer && showLegalInfo ? (
                    <div className="form__desc">
                        Нажимая кнопку «Получить подарок», я соглашаюсь с{" "}
                        <a href="https://ris.promo/pdf/privacy.pdf" target="_blank" rel="noreferrer">
                            политикой конфиденциальности
                        </a>
                        , а также даю согласие{" "}
                        <a href="https://ris.promo/pdf/consent_to_advertising.pdf" target="_blank" rel="noreferrer">
                            ООО «РИС»
                        </a>{" "}
                        и{" "}
                        <a
                            // костыль, задача DEV-2701
                            href={promo?.vendor?._id === "668e4671a0021c8424c389ff" ? "https://storage.yandexcloud.net/rp-dev-assets/ris_promo_pdf/ris_promo/t-bank.docx" : `/documents/personal-data/${promo?.vendor?._id}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {promo?.vendor?.vendorInfo?.fullOpf}
                        </a>{" "}
                        на направление мне рекламных сообщений и на{" "}
                        <a href={`/documents/ad-agreement/${promo?.vendor?._id}`} target="_blank" rel="noreferrer">
                            обработку персональных данных
                        </a>
                        .
                    </div>
                ) : null}

                {!promo.ghostOffer && showLegalInfo ? <div className="form__ord">{promo.offerDetail.ordRisPromo}</div> : null}

                <div className="offers__count">
                    <div className="offers__count-item">
                        <img className="offers__count-icon" src={people} />
                        <div className="offers__count-text">
                            <span className="offers__count-value">
                                {number.toLocaleString()} человек{pluralForm(number, ["", "а", ""])}
                            </span>
                            <span className="offers__count-label">сегодня выбрали подарок</span>
                        </div>
                    </div>

                    <div className="offers__count-item">
                        <img className="offers__count-icon" src={light} />
                        <div className="offers__count-text">
                            <span className="offers__count-value">Обновили в {time}</span>
                            <span className="offers__count-label">предложение актуально</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }),
);

const wrap = {
    geo: InheritGeo,
    question: SelectingOptions,
};

const targetIds = ["664746e41feb2258b05f5e68", "664746e41feb2258b05f5e69"];

function extractGeoArrays(geoObject = {}) {
    const regionIds = [];
    const cityIds = [];
    const metroStationIds = [];

    for (const regionId in geoObject) {
        if (!Object.hasOwn(geoObject, regionId)) continue;
        regionIds.push(regionId);

        const regionContent = geoObject[regionId];

        // Обработка городов
        if (regionContent.cities && typeof regionContent.cities === "object") {
            for (const cityId in regionContent.cities) {
                if (Object.hasOwn(regionContent.cities, cityId)) {
                    cityIds.push(cityId);
                }

                const cityContent = regionContent.cities[cityId];

                if (cityContent?.metroStations && typeof cityContent?.metroStations === "object") {
                    for (const metroId in cityContent.metroStations) {
                        if (Object.hasOwn(cityContent.metroStations, metroId)) {
                            metroStationIds.push(metroId);
                        }
                    }
                }
            }
        }

        // Обработка станций метро
        if (regionContent.metroStations && typeof regionContent.metroStations === "object") {
            for (const metroId in regionContent.metroStations) {
                if (Object.hasOwn(regionContent.metroStations, metroId)) {
                    metroStationIds.push(metroId);
                }
            }
        }
    }

    return { regionIds, cityIds, metroStationIds };
}

export default Default;
